import React, { useState, useRef, useEffect } from "react";
import styles from "./style.module.css";
// import Typography from "../Typography/Typography";

export interface Option {
    value: string;
    label: React.ReactNode;
}

interface DropdownProps {
    options: Option[];
    value?: string;
    onChange?: (value: string) => void;
    // placeholder?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
    options,
    value,
    onChange,
    // placeholder = "...",
}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // const selected = options.find((opt) => opt.value === value);

    const handleSelect = (val: string) => {
        onChange?.(val);
        setOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.container} ref={dropdownRef}>
            <button
                type="button"
                className={styles.trigger}
                onClick={() => setOpen((prev) => !prev)}
            >
                {/* <Typography
                    variant="heading3"
                >
                    {selected ? selected.label : placeholder}
                    <span className={styles.arrow}>{open ? "▲" : "▼"}</span> 
                </Typography> */}
                <div className={styles.dotContainer}>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                </div>
            </button>

            {open && (
                <ul className={styles.menu}>
                    {options.map((opt) => (
                        <li
                            key={opt.value}
                            className={`${styles.option} ${opt.value === value ? styles.selected : ""}`}
                            onClick={() => handleSelect(opt.value)}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};